module.exports = __webpack_public_path__ + "static/Pressemeldung_de-2ed0a0a303c22824e960116f01ce7b6e.pdf";